import { Buildings } from '@phosphor-icons/react';

export default function DistributorBalanceOverview({ summary, formatCurrency }) {
  if (!summary) return null;
  return (
    <div className="card-flat" data-testid="distributor-balance-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold flex items-center gap-2">
          <Buildings size={22} className="text-emerald-600" />
          Distributor Balance Overview
        </h2>
        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
          {summary.distributor_count} Distributors
        </span>
      </div>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
        <div className="p-3 bg-green-50 border border-green-200 rounded-lg" data-testid="dist-total-credit">
          <p className="text-[10px] text-green-600 uppercase font-semibold">Total Credit</p>
          <p className="text-xl font-bold text-green-700 font-mono">{formatCurrency(summary.total_credit)}</p>
        </div>
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg" data-testid="dist-total-debit">
          <p className="text-[10px] text-red-600 uppercase font-semibold">Total Debit</p>
          <p className="text-xl font-bold text-red-700 font-mono">{formatCurrency(summary.total_debit)}</p>
        </div>
        <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg" data-testid="dist-net-balance">
          <p className="text-[10px] text-blue-600 uppercase font-semibold">Net Balance</p>
          <p className={`text-xl font-bold font-mono ${summary.net_balance >= 0 ? 'text-blue-700' : 'text-red-700'}`}>
            {formatCurrency(summary.net_balance)}
          </p>
        </div>
      </div>
      {/* Per-Distributor Table */}
      {summary.distributors.length > 0 && (
        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-2.5 font-semibold text-gray-600">Distributor</th>
                <th className="text-left p-2.5 font-semibold text-gray-600">Agencies</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Credit</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Debit</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Balance</th>
              </tr>
            </thead>
            <tbody>
              {summary.distributors.map((d, i) => (
                <tr key={d.email || `dist-${i}`} className="border-t border-gray-100" data-testid={`dist-row-${i}`}>
                  <td className="p-2.5">
                    <p className="font-medium text-gray-900">{d.name}</p>
                    <p className="text-xs text-gray-400">{d.email}</p>
                  </td>
                  <td className="p-2.5">
                    <div className="flex flex-wrap gap-1">
                      {d.agencies.map((a, j) => (
                        <span key={`${a}-${j}`} className="text-[10px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded">{a}</span>
                      ))}
                      {d.agencies.length === 0 && <span className="text-xs text-gray-400">-</span>}
                    </div>
                  </td>
                  <td className="p-2.5 text-right font-mono text-green-600">{formatCurrency(d.credit)}</td>
                  <td className="p-2.5 text-right font-mono text-red-600">{formatCurrency(d.debit)}</td>
                  <td className="p-2.5 text-right">
                    <span className={`font-mono font-bold ${d.balance >= 0 ? 'text-blue-700' : 'text-red-600'}`}>
                      {formatCurrency(d.balance)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
